import React from 'react';
import Helmet from 'react-helmet';
import { AppName } from '../App';

export const Title = (props) => {
    const { title, subtitle } = props;
    return (
        <Helmet>
            {subtitle ?
                <title>
                    {subtitle} | {title || AppName}
                </title>
                :
                <title>
                    {title || AppName}
                </title>
}
        </Helmet>
        );
};


// WEBPACK FOOTER //
// ./src/components/Title.js